"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _Button = _interopRequireDefault(require("../Button"));
var _IconClose = _interopRequireDefault(require("../../icons/General/IconClose"));
var _VisuallyHidden = _interopRequireDefault(require("../../shared/components/VisuallyHidden"));
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsxImportSource @emotion/react */

const Alert = ({
  primary,
  success,
  info,
  danger,
  rounded,
  css,
  children,
  className,
  onClose,
  ...restProps
}) => {
  const ariaLivePolicy = success ? 'polite' : 'assertive';
  // Random id for aria-describedby
  const id = Math.random().toString(36).substring(7);
  const descriptionId = (0, _react.useRef)(`aria-describedby-${id}`);
  const childTextContent = _react.default.Children.toArray(children).filter(child => typeof child === 'string');
  const getDefaultAriaLabel = () => {
    if (success) {
      return 'Suksess';
    }
    if (danger) {
      return 'Fare';
    }
    return 'Informasjon';
  };
  const accessibilityProps = {
    'aria-live': ariaLivePolicy,
    'aria-atomic': restProps['aria-atomic'] || true,
    'aria-label': restProps['aria-label'] || getDefaultAriaLabel(),
    'aria-relevant': restProps['aria-relevant'] || 'all',
    'aria-describedby': descriptionId.current
  };
  return (0, _jsxRuntime.jsxs)("div", {
    role: "alert",
    css: theme => [_styles.styles.default(theme), success && _styles.styles.success(theme), info && _styles.styles.info(theme), danger && _styles.styles.danger(theme), rounded && _styles.styles.rounded, primary && _styles.styles.primary(theme), css && css],
    className: className,
    ...restProps,
    ...accessibilityProps,
    children: [children, onClose && (0, _jsxRuntime.jsx)(_Button.default, {
      onClick: onClose,
      nostyle: true,
      "aria-label": "Lukk",
      children: (0, _jsxRuntime.jsx)(_IconClose.default, {
        size: 14
      })
    }), (0, _jsxRuntime.jsx)(_VisuallyHidden.default, {
      id: descriptionId.current,
      children: childTextContent
    })]
  });
};
var _default = exports.default = Alert;